<template>
  <v-app>
    <fma-header />
    <router-view />
    <v-footer app absolute color="secondary" class="white--text">
      <v-card class="pl-2 white--text" color="secondary" elevation="0">
        {{
          `Made Possible by:    ${sponsors
            .map(sponsor => sponsor.name.replace(" ", "&nbsp;"))
            .join(" ・ ")}`
        }}
      </v-card>
      <v-spacer />
      <v-card class="pr-2 white--text" color="secondary" elevation="0">
        @{{ new Date().getFullYear() }} Fort Meade Alliance Foundation
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import FmaHeader from "@/components/FmaHeader.vue";
import { mapMutations } from "vuex";

export default {
  components: {
    FmaHeader
  },
  computed: {
    sponsors() {
      return this.$store.state.sponsors;
    }
  },
  mounted() {
    this.$store.dispatch("fetchSponsors");
  },
  created() {
    /* Check for kiosk mode flag, if not kiosk mode and entering home screen then direct right to categories */
    const {
      query: { kiosk = undefined },
      name
    } = this.$route;
    if (!kiosk && name == "Home") this.$router.push({ name: "Categories" });
    this.assignKioskMode(!!kiosk);
  },
  methods: {
    ...mapMutations(["assignKioskMode"])
  }
};
</script>

<style lang="less">
@import "./assets/global.less";
</style>
